var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.appUnderMaintenance)?_c('home-page'):_c('div',{staticClass:"under-maintenance"},[_c('p',[_vm._v(_vm._s(_vm.appUnderMaintenanceMessage))])])}
var staticRenderFns = []

export { render, staticRenderFns }